import { useContext, useEffect, useMemo } from "react"
import styles from "./index.module.scss"
import { Spin, message } from 'antd'
import { ExtractionContext } from "../ExtractionContext"
import MultiSemanticMatting from "../MultiSemanticMatting"
import InteractiveMatting from '../InteractiveMatting'
import ExtractionRightCanvas from "../ExtractionRightCanvas"
import eventBus from '@utils/eventBus';
import DragAndScale from "../compoents/MattingOpt/DragAndScale"
import { GenerateContext } from "@utils/GenerateContext"

const ExtractionContent = (props) => {
    const { dimensionReady } = props
    const {
        inputImage, setInputImage,
        multiMasks, setMultiMasks,
        modelBlendedMask,
        setModelBlueMaskBase64,
        modelBlueMaskBase64OriginRef,
        interactiveMode, setInteractiveMode,
        paintMode, setPaintMode,
        paintSize, setPaintSize,
        eraseSize, setEraseSize,
        undoList, setUndoList,
        redoList, setRedoList,
        viewportOffset, setViewportOffset,
        moveable, setMoveable,
        zoom, setZoom,
    } = useContext(ExtractionContext)
    const generate = useContext(GenerateContext)

    const disabledFlag = useMemo(() => {
        return generate.drawType != 'draw'
    }, [generate.drawType])


    return (
        <div className={styles.Container}>
            <div className={styles.LeftContent}>
                {
                    dimensionReady ?
                    <InteractiveMatting // 交互式分割
                        uid={props.uid}
                        addUndo={params => eventBus.emit(`image_extraction_add_undo_${props.uid}`, params)}
                        addRedo={params => eventBus.emit(`image_extraction_add_redo_${props.uid}`, params)}
                        clearRedo={params => eventBus.emit(`image_extraction_clear_redo_${props.uid}`, params)}
                    /> :
                    <Spin size="large" />
                }
            </div>
            <DragAndScale
                moveable={moveable}
                // disabled={disabledFlag}
                zoom={zoom}
                zoomOut={() => eventBus.emit(`image_extraction_zoom_out_${props.uid}`)}
                zoomIn={() => eventBus.emit(`image_extraction_zoom_in_${props.uid}`)}
                onMoveableReverse={() => setMoveable(pre => !pre)}
                onReset={() => eventBus.emit(`image_extraction_reset_canvas_${props.uid}`)}
            />
        </div>
    )
}

export default ExtractionContent